module.exports = __webpack_public_path__ + "img/rukavy_81_viridian-zelena.1ccc9567.png";